// src/pages/BlogPage.jsx
import React from "react";
import BlogList from "../components/Blog/BlogList";
import SEO from "../components/common/SEO";

const BlogPage = () => {
  // Blog listing page structured data
  const blogListingStructuredData = {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": "Mihir Shah - Security Insights Blog",
    "description": "Expert insights on cloud security, OWASP VXDF, application security, and cybersecurity trends from industry leader Mihir Shah.",
    "url": "https://mihirshah.tech/blog",
    "author": {
      "@type": "Person",
      "name": "Mihir Shah",
      "url": "https://mihirshah.tech"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Mihir Shah",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mihirshah.tech/logo.png"
      }
    },
    "inLanguage": "en-US",
    "about": [
      {
        "@type": "Thing",
        "name": "Cloud Security"
      },
      {
        "@type": "Thing", 
        "name": "OWASP VXDF"
      },
      {
        "@type": "Thing",
        "name": "Application Security"
      },
      {
        "@type": "Thing",
        "name": "DevSecOps"
      }
    ]
  };

  return (
    <>
      <SEO
        title="Security Insights Blog - Cloud Security & OWASP VXDF"
        description="Expert insights on cloud security, OWASP VXDF, application security, and cybersecurity trends. Technical articles and research from security industry leader Mihir Shah."
        keywords="cloud security blog, OWASP VXDF articles, cybersecurity insights, DevSecOps blog, application security, vulnerability management, security research"
        url="https://mihirshah.tech/blog"
        type="website"
        section="Blog"
        tags={["Blog", "Cloud Security", "OWASP VXDF", "Cybersecurity"]}
        structuredData={blogListingStructuredData}
      />
      <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900">
        <div className="pb-20">
          <div className="container mx-auto px-4">
            <BlogList />
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogPage;
